import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=2565b21f&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=2565b21f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2565b21f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2565b21f')) {
      api.createRecord('2565b21f', component.options)
    } else {
      api.reload('2565b21f', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=2565b21f&scoped=true&", function () {
      api.rerender('2565b21f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2964XSr8RjISn/JS/comp/Voucher.vue"
export default component.exports